import { useParams } from "react-router-dom"
import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

const admissibleIconSrc = require('../../../../../assets/images/fontAwesomeIcons/check-circle-regular.svg').default
const inadmissibleIconSrc = require('../../../../../assets/images/fontAwesomeIcons/circle-xmark-regular.svg').default

// PathNormativitiesMeasureType
export default function PNMTContent() {
    const { measureType } = useParams()
    const tooltipRoadName = useAppSelector(state => state.mapTooltip.tooltipRoadName)
    const tooltipPathName = useAppSelector(state => state.mapTooltip.tooltipPathName)
    const tooltipSegmentStart = useAppSelector(state => state.mapTooltip.tooltipSegmentStart)
    const tooltipSegmentEnding = useAppSelector(state => state.mapTooltip.tooltipSegmentEnding)
    const tooltipNormativityMarker = useAppSelector(state => state.mapTooltip.tooltipNormativityMarker)

    let pathNormativity: any
    let showPathNormativityAdmissible
    let showPathNormativityInadmissible
    let pathNormativityAdmissiblePercent
    let pathNormativityAdmissible
    let pathNormativityInadmissiblePercent
    let pathNormativityInadmissible
    const pathNormativitiesForMapTooltip = useAppSelector(state => state.diagnosticsPathNormativities.pathNormativitiesForMapTooltip)
    if (pathNormativitiesForMapTooltip) {
        pathNormativity = pathNormativitiesForMapTooltip.filter((item: any) => item.PathRoadName === tooltipRoadName && item.PathDescription === tooltipPathName)[0]
        pathNormativityAdmissiblePercent = pathNormativity?.[`${measureType}AdmissiblePercent`]?.toFixed(1).replace('.', ',')
        pathNormativityAdmissible = pathNormativity?.[`${measureType}Admissible`]?.toFixed(2).replace('.', ',')
        pathNormativityInadmissiblePercent = pathNormativity?.[`${measureType}InadmissiblePercent`]?.toFixed(1).replace('.', ',')
        pathNormativityInadmissible = pathNormativity?.[`${measureType}Inadmissible`]?.toFixed(2).replace('.', ',')
        showPathNormativityAdmissible = Boolean(pathNormativityAdmissiblePercent || pathNormativityAdmissible)
        showPathNormativityInadmissible = Boolean(pathNormativityInadmissiblePercent || pathNormativityInadmissible)
    }

    return (
        <>
            {showPathNormativityAdmissible &&
                <div className="tooltip-info-row admissible">В нормативе: {pathNormativityAdmissiblePercent}% {pathNormativityAdmissible} км</div>
            }
            {showPathNormativityInadmissible &&
                <div className="tooltip-info-row inadmissible">Не в нормативе: {pathNormativityInadmissiblePercent}% {pathNormativityInadmissible} км</div>
            }
            <div className="tooltip-info-row normativity-segment">
                <span>Участок: {(tooltipSegmentStart && tooltipSegmentEnding) ? ` ${tooltipSegmentStart} - ${tooltipSegmentEnding} км` : 'Не известен'}</span>
                <img src={tooltipNormativityMarker ? admissibleIconSrc : inadmissibleIconSrc} />
                <span>{tooltipNormativityMarker ? 'В нормативе' : 'Не в нормативе'}</span>
            </div>
        </>
    )
}
